export default "__VITE_ASSET__zMqFmA43__"